import { Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import styles from './NoInstitutionsPlaceholder.module.css';

/**
 * Empty-state placeholder shown in the main content area when a super admin
 * has at least one organization but no institution selected or created yet.
 * The heading is rendered by TopPanel; this only holds the placeholder body text.
 * @returns The no-institution placeholder
 */
export const NoInstitutionsPlaceholder = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Typography
        as="span"
        fontWeight={500}
        fontSize="20px"
        color="var(--colors-secondary)"
      >
        {t('nav-panel.no-institutions-placeholder')}
      </Typography>
    </div>
  );
};
